module.exports = __webpack_public_path__ + "static/media/photo182.d213b1b0.jpg";